// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"521a8d06","243":"0f5f039e","246":"0f5f039e","838":"b601049f","860":"0f5f039e"}[chunkId] + ".chunk.css";
};